<!--
**************************************
*  名称：导航头
*  作用：导航栏 退出登录 修改密码
*  作者：闫聪洋
**************************************
-->
<template>
	<div class="header">
		<el-row class="head-nav">
			<el-col :span="4" class="logo-box">
				<img :src="logoImg"  v-bind:class={topLogoImg:topLogoImg}>
                <b>{{apiRootName}}</b>
			</el-col>
			<el-col :span="16">
                <el-row v-if="dataroles==0" >
                    <el-col :span="22">
						<el-menu :default-active="$route.path" router mode="horizontal">
							<el-menu-item class='color-fff' v-for="route in routes" :key="route.path" :index="route.path" :class="$route.path==route.path?'is-active':''">{{route.name}}
							</el-menu-item>
							<el-submenu class="allince-menu" index="active"  mode="horizontal">
								<template slot="title">机构管理菜单</template>
								<el-menu-item v-for="routes in agencyProxyRoutes" :key="routes.path" :index="routes.path" :class="$route.path==routes.path?'is-active':''">{{routes.name}}</el-menu-item>
							</el-submenu>
							
							<el-menu-item  key="/other" index="/other" class="color-fff $route.path==/other'is-active':''">其它
							</el-menu-item>
						</el-menu>
                    </el-col>
                    <!-- <el-col :span="2">
                        <img  @click="updatedDalog('0')" class="update-dialog" src="../../static/images/icon-update.png">
                    </el-col> -->
                </el-row>
                <el-row v-if="dataroles == 100">
                     <el-col :span="22">
                        <el-menu :default-active="$route.path" router mode="horizontal">
                            <el-submenu class="allince-menu" index="active1"  mode="horizontal">
								<template slot="title">课程管理菜单</template>
								<el-menu-item v-for="routes in courseManagementRoutes" :key="routes.path" :index="routes.path" :class="$route.path==routes.path?'is-active':''">{{routes.name}}</el-menu-item>
							</el-submenu>
                        </el-menu>
                    </el-col>
                </el-row>
				<!-- <el-row v-if="dataroles==9" >
					<el-col :span="22">
						<el-menu :default-active="$route.path" router mode="horizontal" >
							<el-submenu class="allince-menu" index="active1"  mode="horizontal">
								<template slot="title">课程管理菜单</template>
								<el-menu-item v-for="routes in courseManagementRoutes" :key="routes.path" :index="routes.path" :class="$route.path==routes.path?'is-active':''">{{routes.name}}</el-menu-item>
							</el-submenu>
							<el-menu-item key="/other" index="/other" class="color-fff $route.path==/other'is-active':''">其它
							</el-menu-item>
						</el-menu>
					</el-col>
					
				</el-row> -->
                <el-row v-if="dataroles==6&&requestUnit != 'IsFangCao'&&requestUnit!='IsBeiMa'" >
                    <el-col :span="22">
                     <el-menu :default-active="$route.path" router mode="horizontal" v-if="dataroles==6" >
					<el-menu-item  class='color-fff' v-for="route in allianceRoutes" :key="route.path" :index="route.path" :class="$route.path==route.path?'is-active':''">					
						<span>{{route.name}}</span>
					</el-menu-item>
					<el-submenu class="allince-menu" index="active"  mode="horizontal">
						<template slot="title">信息管理</template>
						<el-menu-item v-for="routes in allianceChildRoutes" :key="routes.path" :index="routes.path" :class="$route.path==routes.path?'is-active':''">{{routes.name}}</el-menu-item>
					</el-submenu>
					<el-menu-item key="/importData" index="/importData" class="color-fff $route.path==/main/import_data?'is-active':''">数据导入
					</el-menu-item>
					<el-menu-item key="/allianceMain/helpCenter/introduction" index="/allianceMain/helpCenter/introduction" class="color-fff $route.path==/main4/introduction?index=3'is-active':''">帮助中心
					</el-menu-item>
				</el-menu>
                </el-col>
                   
                </el-row>
				<el-row v-if="dataroles==6&&(requestUnit=='IsFangCao'||requestUnit=='IsBeiMa')" >
					<el-col :span="22">
					<el-menu :default-active="$route.path" router mode="horizontal" v-if="dataroles==6" >
					<el-menu-item  class='color-fff' v-for="route in fangCaoAllianceRoutes" :key="route.path" :index="route.path" :class="$route.path==route.path?'is-active':''">					
						<span>{{route.name}}</span>
					</el-menu-item>
					<el-menu-item key="/importData" index="/importData" class="color-fff $route.path==/main/import_data?'is-active':''">数据导入
					</el-menu-item>
                    <el-submenu class="allince-menu" index="active" mode="horizontal">
						<template slot="title">课程管理菜单</template>
						<el-menu-item v-for="routes in courseManagementRoutes" :key="routes.path" :index="routes.path" :class="$route.path==routes.path?'is-active':''">{{routes.name}}</el-menu-item>
					</el-submenu>
                    <!-- <el-col :span="4">
                        <el-menu :default-active="$route.path" router mode="horizontal">
                            <el-submenu class="allince-menu" index="active1"  mode="horizontal">
								<template slot="title">课程管理菜单</template>
								<el-menu-item v-for="routes in courseManagementRoutes" :key="routes.path" :index="routes.path" :class="$route.path==routes.path?'is-active':''">{{routes.name}}</el-menu-item>
							</el-submenu>
                        </el-menu>
                    </el-col> -->
				</el-menu>
				</el-col>
					
					
				</el-row>
                
                 <el-row v-if="dataroles==4" >
                    <el-col :span="22">
				    <el-menu :default-active="$route.path" router mode="horizontal" v-if="dataroles==4" >
					    <el-menu-item  class='color-fff' v-for="route in agencyRoutes" :key="route.path" :index="route.path" :class="$route.path==route.path?'is-active':''">{{route.name}}</el-menu-item>
                    </el-menu>
                 </el-col>
                   
                </el-row>
                 <el-row v-if="dataroles==5&&requestUnit=='IsFangCao'" >
                    <el-col :span="22">
                    <el-menu :default-active="$route.path" router mode="horizontal" v-if="dataroles==5">
                        <el-menu-item  class='color-fff' v-for="route in fangCaoProxyRoutes" :key="route.path" :index="route.path" :class="$route.path==route.path?'is-active':''">{{route.name}}</el-menu-item>
                    </el-menu>
                    </el-col>
                   
                </el-row>
                <el-row v-if="dataroles==5&&requestUnit!= 'IsFangCao'" >
                    <el-col :span="22">
                    <el-menu :default-active="$route.path" router mode="horizontal" v-if="dataroles==5">
                        <el-menu-item  class='color-fff' v-for="route in proxyRoutes" :key="route.path" :index="route.path" :class="$route.path==route.path?'is-active':''">{{route.name}}</el-menu-item>
                    </el-menu>
                    </el-col>
                   
                </el-row>
				<el-row v-if="dataroles==1&&(requestUnit=='IsFangCao'||requestUnit=='IsBeiMa')" >
					<el-col :span="22"> 
					<el-menu :default-active="$route.path" router mode="horizontal" v-if="dataroles==1" >
					<el-menu-item  class='color-fff' v-for="route in fangCaoKgRoutes" :key="route.path" :index="route.path" :class="$route.path==route.path?'is-active':''">{{route.name}}</el-menu-item>
					<el-submenu class="allince-menu" index="active" mode="horizontal">
						<template slot="title">数据处理</template>
						<el-menu-item v-for="routes in kindergartenDataBase" :key="routes.path" :index="routes.path" :class="$route.path==routes.path?'is-active':''">{{routes.name}}</el-menu-item>
					</el-submenu>
				</el-menu>
				</el-col>
					
				</el-row>
                
				<el-row v-if="dataroles==1&&requestUnit != 'IsFangCao'&&requestUnit!='IsBeiMa'" >
					<el-col :span="22">
					<el-menu :default-active="$route.path" router mode="horizontal" v-if="dataroles==1" >
					<el-menu-item  class='color-fff' v-for="route in kgRoutes" :key="route.path" :index="route.path" :class="$route.path==route.path?'is-active':''">{{route.name}}</el-menu-item>
					<el-submenu class="allince-menu" index="active" mode="horizontal">
						<template slot="title">数据处理</template>
						<el-menu-item v-for="routes in kindergartenDataBase" :key="routes.path" :index="routes.path" :class="$route.path==routes.path?'is-active':''">{{routes.name}}</el-menu-item>
					</el-submenu>
				</el-menu>
				</el-col>
					
				</el-row>
                
				<el-row v-if="dataroles==7&&requestUnit != 'IsFangCao'" >
					<el-col :span="22">
					<el-menu :default-active="$route.path" router mode="horizontal" v-if="dataroles==7" >
					<el-menu-item  class='color-fff' v-for="route in kgRoutesProbation" :key="route.path" :index="route.path" :class="$route.path==route.path?'is-active':''">{{route.name}}</el-menu-item>
					<el-submenu class="allince-menu" index="active" mode="horizontal">
						<template slot="title">数据处理</template>
						<el-menu-item v-for="routes in kindergartenDataBase" :key="routes.path" :index="routes.path" :class="$route.path==routes.path?'is-active':''">{{routes.name}}</el-menu-item>
					</el-submenu>
				</el-menu>
				</el-col>
					
				</el-row>
			</el-col>
			<el-col :span="4">
				<el-dropdown class="userinfo ">
					<span class="el-dropdown-link userinfo-inner">
						<img src="/static/images/user-icon.png" />
					    {{admin}} <i class="el-icon-arrow-down"></i>
					  </span>
					<el-dropdown-menu slot="dropdown" class="userinfo-dropdown">
						<el-dropdown-item v-if="dataroles!==0">
							<span @click="dialogFormVisible = true">
									修改密码
							</span>
						</el-dropdown-item>
						<el-dropdown-item v-else>
						</el-dropdown-item>
						<el-dropdown-item>
							<span v-on:click="logout">
									退出登录
								</span>
						</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
			</el-col>
		</el-row>
        <!-- 修改密码 -->
		<el-dialog title="修改密码" :visible.sync="dialogFormVisible" width="30%">
			<el-form :model="passForm" label-width="70px" :rules="passFormRules" ref="passForm">
				<el-form-item label="旧密码" prop="oldPassword">
					<el-input v-model="passForm.oldPassword" type="password" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="新密码" prop="newPassword">
					<el-input v-model="passForm.newPassword" type="password" auto-complete="off"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-row>
					<el-col :span="5" :offset="5">
						<el-button @click="dialogFormVisible = false">取 消</el-button>
					</el-col>
					<el-col :span="8">
						<el-button type="primary" @click.native="editSubmit">提 交</el-button>
					</el-col>
				</el-row>
			</div>
		</el-dialog>
        <!-- 版本更新公告 -->
        <el-dialog title="版本更新" :visible.sync="dialog" width="30%">
			<el-form  label-width="70px" >
				<p class="update-dialog-p" v-html="dalogTxt"></p><br>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-row>
					<el-col :span="5" :offset="8">
						<el-button type="primary"  @click="dialog = false">确 定</el-button>
					</el-col>
				</el-row>
			</div>
		</el-dialog>

	</div>
</template>
<script>
import Vue from 'Vue';
import context from '../utils/context';
import config from '../assets/js/config';
import router from '../router';
import navHead from '../assets/js/nav-head';
import { reqList } from '../api/api';

export default {
    data() {
        return {
            requestUnit:'',
            apiRootName: '',
            logoImg: '',
            dialogFormVisible: false,
            dialog: false,
            dalogTxt: '',
            passForm: {
                oldPassword: '',
                newPassword: ''
            },
            admin: '',
            dataroles:0,
            topLogoImg:false,
            passFormRules: {
                oldPassword: [
                    {
                        required: true,
                        message: '请输入密码',
                        trigger: 'blur'
                    }
                ],
                newPassword: [
                    {
                        required: true,
                        message: '请输入密码',
                        trigger: 'blur'
                    }
                ]
            },
            routes: navHead.routes,
            allianceRoutes: navHead.allianceRoutes,
            agencyRoutes: navHead.agencyRoutes,
            proxyRoutes: navHead.proxyRoutes,
            kgRoutes: navHead.kgRoutes,
            kgRoutesProbation: navHead.kgRoutesProbation,//试用期
            fangCaoKgRoutes: navHead.fangCaoKgRoutes,//芳草园长
            fangCaoAllianceRoutes:navHead.fangCaoAllianceRoutes,//芳草加盟商
            fangCaoProxyRoutes:navHead.fangCaoProxyRoutes,//芳草代理
            //下拉子菜单
            kindergartenDataBase: navHead.kindergartenDataBase,
            allianceChildRoutes: navHead.allianceChildRoutes,
            agencyProxyRoutes: navHead.agencyProxyRoutes,
            courseManagementRoutes: navHead.courseManagementRoutes,
            roleTypes: context.RoleType
        };
    },

    methods: {
        // 新本提示：  "0":"管理员", 		        
        updatedDalog(type) {
            let txt =
                '版本：4.9<br>更新日期：2018.10.29<br><br>更新内容：<br>1.幼儿管理新增批量离校功能，孩子离校及毕业操作更方便;<br>2.修复其他已知bug，优化使用体验;<br>';
            let txtObj = {
                '0': txt,
                '1': txt,
                '4': txt,
                '6': txt,
                '5': txt
            };
            this.dialog = true;
            this.dalogTxt = txtObj[type];
        },
        unlockingUser() {
            let _this = this;
            this.$confirm('您确定要为用户解锁码?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    _this.$http.put('auth/logout');
                    this.$message({
                        type: 'success',
                        message: '解锁成功!'
                    });
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消解锁'
                    });
                });
        },
        getKdgRoleType() {
            let unitType = context.UnitType;
            let userNameObj = {
                '1': '园长',
                '4': '机构',
                '6': '加盟商',
                '5': '代理',
                '9': '课程管理员'
            };
            if(context.RequestUnit=='IsFangCao'){
                // debugger
                if(context.RoleType==0){
                    this.dataroles=0
                }else{
                    //  debugger
                    this.dataroles=unitType     
                };
                this.admin ='管理员';
            }else{
                 if(context.RoleType==0){
                    this.dataroles = 0;
                    this.admin ='管理员';
                }else if(context.RoleType == 100){
                    // debugger;
                    this.dataroles = 100;
                    this.admin ='管理员';
                }else{
                    if(context.IsProbation=='true'){
                        this.dataroles = 7;//试用园
                        this.admin = userNameObj[1];
                    }else{
                         this.dataroles = unitType;
                        this.admin = userNameObj[unitType];
                    }
                   
                };
            }
        },
        //退出登录
        logout: function() {
            var _this = this;
            this.$confirm('确认退出吗?', '提示', {}).then(() => {
                _this.$http.get('auth/logout');
                context.Clear();
                _this.$router.push('/');
            });
        },
        editSubmit: function() {
        	if(context.IsFakeAccount == 'true'){
        		alert('试用账号无法修改密码');

			}else {
            this.$refs.passForm.validate(valid => {
                if (valid) {
                    let para = {
                        OldPassword: this.passForm.oldPassword,
                        NewPassword: this.passForm.newPassword
                    };
                    this.$http
                        .put('/password', para)
                        .then(response => {
                            if (response.status == 200) {
                                this.$message({
                                    message: '修改成功',
                                    type: 'success'
                                });
                                this.dialogFormVisible = false;
                                var _this = this;
                                _this.$http.get('auth/logout');
                                context.Clear();
                                _this.$router.push('/');
                            }
                        })
                        .catch(() => {
                            this.$message({
                                message: '请检查输入是否正确',
                                type: 'error'
                            });
                        });
                }
            });}
        },
         getKdgInfo: function(kdgName) {
             let unitType = context.UnitType;
             let roleType = context.RoleType;
            this.dataroles=(roleType==0 || roleType == 100)?roleType:unitType
             
            let parameter = {
                UnitType: 1,
                PageIndex: 1,
                Keyword:kdgName,
                PageSize: 20
            };
            console.log(this.dataroles);
            reqList(parameter).then((res) => {
                // console.log(res);
                this.loading = false;
                if(res.data) {
                    let kdgList=res.data.KdgList;
                    kdgList.forEach(element => {
                        if(element.Resullts.AllianceName=='体测教师培训班'){
                            context.IsProbation=true;
                        }else{
                            context.IsProbation=false;
                        };
                    });
                };
                 this.getKdgRoleType();
            });
        }
    },
    mounted() {
        this.getKdgInfo(context.KindergartenName);//是否使用账号
        // this.getKdgRoleType();
        let apiRoot = window.location.host.split('.')[0];
        let adminUser = config.apiRoot[apiRoot];
        this.apiRootName = adminUser.Name;
        this.requestUnit=adminUser.RequestUnit;
        context.RequestUnit=adminUser.RequestUnit;;
        this.topLogoImg=adminUser.Title=='贝玛教育'?true:false;
        this.logoImg = '/static/images/' + adminUser.Logo;
    }
};
</script>
<style lang="less">
@media print {
    .header {
        display: none;
    }
}
.el-menu--horizontal {
    border-bottom: 0px solid #e6e6e6 !important;
}

.head-nav .el-submenu__title {
    height: 65px !important;
    border-bottom: 0 !important;
    color: #ffffff !important;
    line-height: 70px !important;
    font-size: 16px !important;
}


.head-nav .el-submenu__icon-arrow {
    color: #ffffff !important;
}

.el-dropdown-menu {
    margin-top: -5px !important;
    text-align: center !important;
}

.allince-menu .el-menu {
    border: none !important;
    width: 130px !important;
    box-shadow: 0 0 5px 3px #e4e5e9 !important;
}

.allince-menu .el-menu,
.allince-menu .el-menu li {
    // background: #fff !important;
    color: #666666 !important;
}

.allince-menu .el-menu .is-active {
    color: #666666 !important;
}
</style>

<style scoped lang="less">
.color-fff{
   color: #ffffff !important;
}
.head-nav {
    width: 100%;
    height: 70px;
    // background: @main-color;
    position: fixed !important;
    top: 0;
    left: 0;
    z-index: 999;
    // border-bottom: 4px solid @top-border;
    text-align: center;
}

.logo-box {
    padding-left: 60px;
    padding-top: 20px;
}

.logo-box img {
    height: 30px;
    float: left;
}
.topLogoImg{
    width: 4.2rem !important;
    height: 4.2rem !important;
    margin-top: -1.3rem !important;
}
.logo-box b {
    float: left;
    color: #ffffff;
    font-size: 16px;
    padding-top: 8px;
    padding-left: 10px;
}

.el-menu {
    // background: @main-color !important;
    
}

.el-menu li {
    height: 66px !important;
    min-width: 120px !important;
    line-height: 70px !important;
    font-size: 16px !important;
    // color: #ffffff !important;

}

.el-menu-item {
    //  color: #ffffff !important;

}
.el-menu-item.is-active {
    // background: @top-hover-color !important;
    // color: #fff !important;
}

.el-menu li a {
    text-decoration: none !important;
    display: block !important;
    height: 70px !important;
}

.el-menu li:hover {
    // background: @top-hover-color !important;
    border-bottom: 0px solid transparent !important;
    // color: #666666 !important;
}

.el-dropdown {
    // color: #fff !important;
    font-size: 16px !important;
}

.last-tab:hover {
    // background: @top-hover-color !important;
    border-bottom: 0px solid transparent !important;
    // color: #000000 !important;
}

.last-tab {
    // background: #da2337 !important;
}

.is-active {
    // background: @top-hover-color;
    border-bottom: 0px solid transparent;
    // color: #ffffff;
}

.userinfo {
    cursor: pointer;
    line-height: 70px;
    color: #ffffff!important;
    font-size: 16px;
}

.userinfo span {
    height: 60px;
    display: block;
}

/*版本弹出层 */
.update-dialog {
    height: 3rem;
    line-height: 1.5rem;
    cursor: pointer;
}

.update-dialog-p {
    line-height: 1.5rem;
}
</style>



// WEBPACK FOOTER //
// headTop.vue?82f3c928